import ImageGrid from "@components/ImageGrid"
import React from "react"

import { ContentfulContentBaseProps } from "../types"

interface ContentfulImageGridProps extends ContentfulContentBaseProps {}

const ContentfulImageGrid: React.FC<ContentfulImageGridProps> = ({
  blockId,
  captions,
  images,
}) => {
  return (
    <ImageGrid
      blockId={blockId}
      captions={captions}
      images={images.map((image) => image?.file?.url)}
    />
  )
}

export default ContentfulImageGrid
